import { IColourScheme, TagSimpleModal } from '@tag/tag-components-react-v3';
// import FocusTrap from 'focus-trap-react';
import React from 'react';

import { CommonElementProps } from '../Common/CommonElementProps';

export interface SimpleModalProps extends CommonElementProps {
  readonly open?: boolean;
  readonly modalAriaLabel?: string;
  readonly modalAriaLabelledBy?: string;
  readonly modalAriaDescribedBy?: string;
  readonly contentStyle?: React.CSSProperties;
  readonly children: React.ReactNode;
  readonly colourScheme?: IColourScheme;
  readonly onOpenChange?: (
    e: CustomEvent<{
      open: boolean;
    }>,
  ) => void;
}

const SimpleModal = (props: SimpleModalProps): JSX.Element =>
  props.open ? (
    // <FocusTrap>
    <div>
      <TagSimpleModal {...props} data-testid={props.dataTestId} className={props.className} />
    </div>
    // </FocusTrap>
  ) : <></>;

export default SimpleModal;
